<template>
    <div class="Config">
    <section>
        <div class="box">

            <div class="">
                
                <div class="">
                    <b-field label="Dataset name">
                        <b-input v-model="dataset.name" maxlength="40" :value="dataset.name"></b-input>
                    </b-field>
                    <b-field label="Description">
                        <b-input v-model="dataset.description" maxlength="100" :value="dataset.description"></b-input>
                    </b-field>
                    <!-- <b-field label="Dataset version" v-if="versions">
                        <b-select placeholder="Select a dataset version" 
                        expanded v-for="(version, index) in versions"
                        :key="index" v-model="selectedVersion">
                            <option :value="version.id" selected>{{ version.name }}</option>
                        </b-select>
                    </b-field> -->
                    <b-field label="Text column">
                        <b-input v-model="dataset.text" disabled></b-input>
                    </b-field>
                    <b-field label="Labels" v-if="dataset.labels">
                        <b-taginput
                            v-model="dataset.labels"
                            size="is-large">
                        </b-taginput>

                    </b-field>
                    <b-field label="Label column" v-else>
                        <b-input v-model="dataset.label" disabled></b-input>
                    </b-field>
                    
                            

                    <b-field label="User owner">
                        <b-input v-model="user.email" disabled></b-input>
                    </b-field>

                </div>

                <!-- <div v-if="currentUser.admin != undefined && currentUser.admin == true">
                    

                    <div class="block">
                        <b-field label="Turn as public">
                            <b-checkbox v-model="dataset.public">
                                {{ dataset.public }}
                            </b-checkbox>
                        </b-field>
                    </div>
                </div> -->
                <br><br>
                
                <div class="block" v-if="!dataset.public || (dataset.userId == currentUser.id)">
                    <div class="buttons">
                    
                        <b-button  type="is-primary" @click="update" class="success">Update</b-button>
                    
                        <b-button type="is-danger" @click="isCardModalActive = true">Permanent delete</b-button>
                    </div>
                </div>

                
            
            </div>
        </div>

        
        <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
            <div class="card">
                <div class="card-image">
                    
                </div>
                <div class="card-content">
                    <div class="media">
                        <div class="media-left">
                            
                        </div>
                        <div class="media-content">
                            <p class="title is-4">Are you sure?</p>
                            <p class="subtitle is-6">Dataset name: {{ dataset.name}}<br>
                            Dataset Id: {{ dataset.id}}</p>
                            <p class="subtitle is-6">type <b>delete</b> to confirm</p>
                        </div>
                    </div>

                    <div class="content">
                        <b-input v-model="deleteConfirm" placeholder="Type the delete to confirm" size="is-large"/>
                        <br>
                        <b-button @click="isCardModalActive = false">Cancel</b-button>&nbsp;
                        <b-button @click="deletion">Permanent delete</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>

    </div>
</template>
<script>
   export default {
     props: ["dataset", "currentUser"],
     name: "Config",
     data: function() {
    return {
        versions: false,
        userPermission: "Manager",
        permissions: {
            id: 'Manager', s: true, id: 'Collaborator', s: false, id: 'Viewer', s: false
        },
        selectedVersion: 'v1',
        isCardModalActive: false,
      deleteConfirm: null,
      options: {
        plotOptions: {
            pie: {
            customScale: 0.8
            }
        },
      },
       animated: true
    }},
     computed: {
       model() {
         return this.$store.state.currentDataset;
       },
       user() {
         return this.$store.state.getUser;
       }
     },
     methods: {
         update(){
            const toUpdate = {
                datasetId: this.dataset.id,
                update: {
                    name: this.dataset.name,
                    description: this.dataset.description || null,
                    public: this.dataset.public || false,
                    labels: this.dataset.labels
                }
            }
            this.$store.dispatch("updateDataset", 
                toUpdate
            );
         },
         deletion() {

             if (this.deleteConfirm == "delete") {
                const datasetId = this.dataset.id
                 
                this.$buefy.notification.open('Dataset deleted: ' + this.dataset.name)

                 // alert("deleting: " + modelId)
                this.$store.dispatch("deleteDataset", 
                    datasetId
                );
                

                setTimeout(() => 
                this.$router.push("/explore"), 
                1 * 1000)

             }

         }
     },
     created() {
       // console.log(this.pageId)
       this.$store.dispatch("getUser", this.dataset.userId);
       
       this.training = true
       this.options = {},
       this.currentTab = "config"
       this.versions = [
          {id: 'v1', name: 'v1 ' + this.dataset.filename + ' created at '+ this.dataset.createdAt.toDate()}
        ]
     }
   };
</script>